export const CI = navigator.userAgent === 'Autonomic Bot';

document.addEventListener('throw', e => {
  // need to use an event since throwing in promises will simply reject the promise
  // and an uncaught exception needds to be thrown to be caught by puppeteer and jest
  throw new Error(e);
});
